import { Box } from '@mui/material';
import { ArchivedIndicator, StarredIndicator, UnreadIndicator } from '../inbox-widget/styles/inbox-preview-card-styles';
import { Status } from './communications-widget';

interface CommStatusOnlyProps {
  finalStatus: Status;
}

export const CommunicationStatus = ({ finalStatus }: CommStatusOnlyProps) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }} className="communication-status">
      {finalStatus.isUnread && <UnreadIndicator sx={{ marginRight: '4px' }} />}
      {finalStatus.isSaved && <StarredIndicator sx={{ marginRight: '4px' }} />}
      {finalStatus.isArchived && <ArchivedIndicator sx={{ marginRight: '4px' }} />}
    </Box>
  );
};
